export enum TrustPilotUrl {
  CLEAR_ESTATE_REVIEWS_URL = 'https://ca.trustpilot.com/review/clearestate.com',
  BOOTRSTAP_WIDGET_URL = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
}
